import React from 'react';
import { Icon } from './Icon.js';
export const IconVShapedArrowLeftFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M6.64621 0.804807C6.892 0.471685 7.3617 0.400991 7.69504 0.646604C8.02816 0.892396 8.09885 1.3621 7.85324 1.69543L4.68136 6.00012L7.85324 10.3048C8.09885 10.6381 8.02816 11.1078 7.69504 11.3536C7.3617 11.5992 6.892 11.5286 6.64621 11.1954L3.14621 6.44543C2.95126 6.18087 2.95126 5.81937 3.14621 5.55481L6.64621 0.804807Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconVShapedArrowLeftFill12.js.map